import assetPath from '/app/xinglets/lebenslauf/pages/startpage/src/assets/cover-letter.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')